import { render, staticRenderFns } from "./FigureBodyList.vue?vue&type=template&id=6aea4b18&scoped=true"
import script from "./FigureBodyList.vue?vue&type=script&lang=js"
export * from "./FigureBodyList.vue?vue&type=script&lang=js"
import style0 from "./FigureBodyList.vue?vue&type=style&index=0&id=6aea4b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aea4b18",
  null
  
)

export default component.exports